<template>
  <div v-if="!hidden">
    <section-title content="Información de Dirección Física" :has-line="true" />
    <div class="p-3">
      <div class="mx-2">
        <div class="row">
          <div class="col-md-4">
            <validation-provider
              v-slot="{ errors }"
              name="addressLine1"
              :rules="!hidden ? 'required' : ''"
            >
              <label class="data-title mb-0">Dirección (Línea 1):</label>
              <custom-input
                v-model="model.addressLine1"
                :custom-error-msg="'La dirección (línea 1) es requerida.'"
                :error="errors[0]"
              />
            </validation-provider>
          </div>

          <div class="col-md-4">
            <label class="data-title mb-0">Municipio:</label>
            <custom-input
              id="municipalityName"
              class="form-control municipalityName"
              disabled
              :value="municipalityName"
            />
          </div>
          <div class="col-md-4">
            <validation-provider
              v-slot="{ errors }"
              name="addressPostalCode"
              :rules="!hidden ? 'required' : ''"
            >
              <custom-input
                v-model="model.zipCode"
                :custom-error-msg="'El código postal es requerido.'"
                :error="errors[0]"
                label="Código Postal:"
                mask-type="ZipcodeExt"
                placeholder="#####-####"
              />
            </validation-provider>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-4">
            <label class="data-title mb-0">Dirección (Línea 2):</label>
            <custom-input v-model="model.addressLine2" />
          </div>

          <div class="col-md-4">
            <label class="data-title mb-0">Latitud:</label>
            <custom-input v-model.number="model.latitude" type="number" />
          </div>
          <div class="col-md-4">
            <label class="data-title mb-0">Longitud:</label>
            <custom-input v-model.number="model.longitude" type="number" />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-4">
            <label class="data-title mb-0">Dirección (Línea 3):</label>
            <custom-input v-model="model.addressLine3" />
          </div>
          <div class="col-md-8">
            <label class="data-title mb-0">Anotaciones Adicionales:</label>
            <custom-input
              v-model="model.additionalAnnotations"
              placeholder="Escribir información adicional de como llegar..."
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import CustomInput from 'CustomInput';
import SectionTitle from 'SectionTitle';

export default {
  name: 'LocationServicePhysicalAddressInfo',
  components: {
    ValidationProvider,
    SectionTitle,
    CustomInput,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    municipality: {
      type: Object,
      default: () => {},
    },
    hidden: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    model: {
      get() {
        return this.value || {};
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    municipalityName() {
      return this.municipality?.name || ' ';
    },
  },
};
</script>

<style scoped lang="scss">
.municipalityName {
  background-color: #f8f8f8;
}
</style>
